import { heroTicker, hotGossips, siteMeta, siteStats } from "@/mocks/gossip";

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[620px] flex-col justify-end overflow-hidden lg:min-h-[760px]">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20night%20city%20skyline%20with%20glowing%20warm%20red%20and%20amber%20neon%20spotlights%2C%20dramatic%20cinematic%20entertainment%20studio%20light%20beams%2C%20moody%20dark%20background%20with%20fog%2C%20high%20contrast%20editorial%20magazine%20aesthetic%2C%20no%20people%2C%20rich%20textured%20atmosphere&width=1600&height=900&seq=heigua-hero-2026&orientation=landscape"
        alt="夜晚城市霓虹与舞台灯光交织的抽象娱乐氛围背景"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/60 to-foreground-950/90" aria-hidden="true" />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/60 via-transparent to-transparent" aria-hidden="true" />

      <div className="shell relative z-10 pb-10 pt-28 md:pt-36">
        <div className="grid grid-cols-1 items-end gap-10 lg:grid-cols-[1.55fr_1fr]">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/10 px-3 py-1.5 text-xs text-background-100 backdrop-blur">
              <span className="relative flex h-2 w-2 items-center justify-center">
                <span className="live-dot absolute h-full w-full rounded-full bg-primary-400" />
                <span className="relative h-2 w-2 rounded-full bg-primary-500" />
              </span>
              蹲点进行中 · 全天候实时更新
            </span>

            <h1 className="mt-5 font-heading text-4xl leading-[1.15] text-background-50 md:text-6xl">
              {siteMeta.name} · 蹲守第一现场，新瓜抢先吃
            </h1>

            <p className="mt-5 max-w-xl text-sm leading-7 text-background-100/85 md:text-base md:leading-8">
              第一手最新鲜的爆料都在这里。我们蹲守娱乐现场，实时更新正在发酵的事件与瓜料，把零散的路透、动态和现场反馈串成一条你看得懂的脉络。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a href="#hot" className="btn-primary">
                <i className="ri-fire-line" aria-hidden="true" />
                看今日热瓜
              </a>
              <a
                href="#timeline"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 bg-background-50/10 px-5 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 focus:outline-none focus:ring-2 focus:ring-background-50/50"
              >
                <i className="ri-radar-line" aria-hidden="true" />
                查看蹲点日历
              </a>
            </div>

            <dl className="mt-9 grid grid-cols-2 gap-4 border-t border-background-50/15 pt-6 sm:grid-cols-4">
              {siteStats.map((stat) => (
                <div key={stat.label} className="border-l border-background-50/20 pl-4">
                  <dt className="font-heading text-xl text-accent-300 md:text-2xl">{stat.value}</dt>
                  <dd className="mt-1 text-xs text-background-100/70">{stat.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <aside className="rounded-lg border border-background-50/15 bg-foreground-950/45 p-5 backdrop-blur">
            <div className="flex items-center justify-between">
              <h2 className="flex items-center gap-2 font-heading text-lg text-background-50">
                <i className="ri-flashlight-line text-primary-400" aria-hidden="true" />
                实时爆点
              </h2>
              <span className="text-[11px] text-background-100/60">滚动更新</span>
            </div>
            <ul className="mt-4 space-y-4">
              {hotGossips.slice(0, 3).map((item, index) => (
                <li key={item.id} className="flex gap-3 border-b border-background-50/10 pb-4 last:border-0 last:pb-0">
                  <span className="mt-0.5 font-heading text-lg leading-none text-primary-400">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <p className="text-sm leading-6 text-background-100/90">{item.title}</p>
                    <p className="mt-1.5 flex items-center gap-2 text-[11px] text-background-100/55">
                      <span className="rounded-sm bg-accent-500/20 px-1.5 py-0.5 text-accent-200">{item.category}</span>
                      {item.time}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </div>

      <div className="relative z-10 mt-2 border-y border-background-50/15 bg-foreground-950/60 py-3 backdrop-blur">
        <div className="flex w-max marquee-track">
          {[...heroTicker, ...heroTicker].map((text, index) => (
            <span
              key={`${text}-${index}`}
              className="flex items-center gap-2.5 whitespace-nowrap px-6 text-sm text-background-100/85"
            >
              <i className="ri-fire-line text-primary-400" aria-hidden="true" />
              {text}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}